import { useEffect, useState } from "react";
import "../css/carouselS.css";

function CarouselS({ items, interval = 3000 }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) =>
                prev === items.length - 1 ? 0 : prev + 1
            );
        }, interval);

        return () => clearInterval(timer);
    }, [items.length, interval]);

    return (
        <div className="carousel">

            {items.map((item, index) => (
                <div
                    className={`carousel-slide ${
                        index === currentIndex ? "active" : ""
                    }`}
                    key={index}
                >
                    <img src={item} alt={`Product ${index + 1}`} />
                </div>
            ))}

        </div>
    );
}

export default CarouselS;